export const TAGS_ROUTE = '/tags';
